import { MeasureList } from '../../app/feathers/measure-lists';

export const MEASURE_LIST_STEPS = [
  { name: 'Upload Data', routeName: 'upload-data' },
  { name: 'Map Columns', routeName: 'map-columns' },
  { name: 'Verify Data', routeName: 'verify-data' },
  { name: 'Implementation districts', routeName: 'implementation-districts' },
  { name: 'Create', routeName: 'create' }
] as const;

export type MeasureListStepName = typeof MEASURE_LIST_STEPS[number]['routeName'];
export type MeasureListStatus = MeasureList['status'];

export const isMeasureListStepName = (value?: string): value is MeasureListStepName => (
  MEASURE_LIST_STEPS.some(step => step.routeName === value)
);

export const getProgressStepIndex = (status?: MeasureListStatus, isNew = false) => {
  if (isNew) return 0;
  if (status === 'started') return 1;
  if (status === 'labeled') return 2;
  if (status === 'matched') return 3;
  if (status === 'scouted' || status === 'created') return 4;
  return 0;
};

export const isStepAvailable = (
  stepName: MeasureListStepName,
  status?: MeasureListStatus,
  isNew = false
) => {
  const stepIndex = MEASURE_LIST_STEPS.findIndex(step => step.routeName === stepName);
  const progressStepIndex = getProgressStepIndex(status, isNew);

  if (status === 'created') return stepName === 'create';
  if (stepIndex === progressStepIndex) return true;

  return stepIndex >= 2 && stepIndex <= progressStepIndex;
};

export const getDisplayedStepName = (
  activeStepName: string | undefined,
  status?: MeasureListStatus,
  isNew = false
): MeasureListStepName => {
  if (
    isMeasureListStepName(activeStepName) &&
    isStepAvailable(activeStepName, status, isNew)
  ) {
    return activeStepName;
  }

  return MEASURE_LIST_STEPS[getProgressStepIndex(status, isNew)].routeName;
};

export const getDisplayedStatus = (
  stepName: MeasureListStepName,
  actualStatus?: MeasureListStatus
): MeasureListStatus | undefined => {
  if (stepName === 'map-columns') return 'started';
  if (stepName === 'verify-data') return 'labeled';
  if (stepName === 'implementation-districts') return 'matched';
  if (stepName === 'create') {
    return actualStatus === 'created' ? 'created' : 'scouted';
  }
  return undefined;
};
